export const trackLogin = (eventCategory, userId, loginMethod, phoneNumber, email) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `page_view`,
      eventName: `success_${eventCategory}_by_${loginMethod}`,
      eventCategory: `${eventCategory === 'login' ? 'login' : 'registration'}`,
      eventAction: `successfully ${eventCategory}`,
      user_id: userId,
      userId: userId,
      no_hp: phoneNumber,
      email: email?.toLowerCase(),
    });
  }
};
